





















































import { Vue, Component, Prop } from 'vue-property-decorator';
import { IField } from '@/dealroom/fields/types/field';
import { EFieldMenuActionType } from '@/dealroom/fields/context-menu/types/enums/field-menu-action-type';
import FieldSettings from '@/dealroom/fields/context-menu/components/menu-components/FieldSettings.vue';
import FieldDelete from '@/dealroom/fields/context-menu/components/menu-components/FieldDelete.vue';
import FieldAlign from '@/dealroom/fields/context-menu/components/menu-components/FieldAlign.vue';
import FieldRecipients from '@/dealroom/fields/context-menu/components/menu-components/FieldRecipients.vue';
import FieldTextSize from '@/dealroom/fields/context-menu/components/menu-components/FieldTextSize.vue';
import FieldDuplicate from '@/dealroom/fields/context-menu/components/menu-components/FieldDuplicate.vue';
import { EAlignFieldType } from '@/dealroom/fields/context-menu/types/enums/align-field-type';
import { IRecipient } from '@/types/Recipient';
import { IUser } from '@/types/User';
import FieldMove from '@/dealroom/fields/context-menu/components/menu-components/FieldMove.vue';
import { IDocumentPage } from '@/types/document-page';
import { EnumDocumentType } from '@/enums/DocumentType';

@Component({
  components: {
    FieldSettings,
    FieldDelete,
    FieldAlign,
    FieldRecipients,
    FieldMove,
    FieldTextSize,
    FieldDuplicate,
  },
  data: () => ({
    EFieldMenuActionType,
  }),
})
export default class FieldContextMenuBody extends Vue {
  @Prop() selectedActionType: EFieldMenuActionType;

  @Prop() fields: IField[];
  @Prop() sender!: IUser;
  @Prop() recipients: IRecipient[];
  @Prop() pages: IDocumentPage[];

  @Prop() textSizes: number[];
  @Prop() pageWidth: number;
  @Prop() documentType: EnumDocumentType;
  @Prop() height: string;
  @Prop() flipped: boolean;

  get showFieldSettings(): boolean {
    return this.fields.length === 1 && this.selectedMenuAction(EFieldMenuActionType.Settings);
  }

  get isTemplate(): boolean {
    return this.documentType === EnumDocumentType.Template;
  }

  selectedMenuAction(type: EFieldMenuActionType): boolean {
    return type === this.selectedActionType;
  }

  handleUpdate(payload: IField[]) {
    this.$emit('update', payload);
  }

  handleDelete() {
    this.$emit('delete');
  }

  handleMove(payload: string) {
    this.$emit('move', payload);
  }

  handleSelectAlign(actionType: EAlignFieldType) {
    this.$emit('align', actionType);
  }

  handleTextSize(size: number) {
    this.$emit('textSize', size);
  }

  handleDuplicate() {
    this.$emit('duplicate');
  }
}
